import axios from "axios";

export default {
    replaceTopics: async (currentTopicId, replacedTopicId, companyId) => {
        const { data } = await axios.post(`/topics/${companyId}/replace/`, {
            current_topic_id: currentTopicId,
            replaced_topic_id: replacedTopicId,
        })

        return data
    },
    getTopics: async () => {
        const { data } = await axios.get(`/topics/`)

        return data
    },
}
